import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import GroupsApi from 'mewe/api/group-api';
import { A } from '@ember/array';
import { showGroupPreviewDialog } from 'mewe/utils/dialogs-common';
import { toGroup } from 'mewe/fetchers/utils';
import { Theme } from 'mewe/constants';
import DiscoverApi from 'mewe/api/discover-api';
import { later } from '@ember/runloop';

export default class MwSuggestedGroups extends Component {
  @service dynamicDialogs;
  @service router;

  @tracked groups = A();

  @action
  fetchSuggestedGroups() {
    GroupsApi.getSuggestedGroups().then((response) => {
      if (response.results.length) {
        this.groups = A(response.results.map((el) => toGroup(el.group)));
      }
    });
  }

  @action
  groupClicked(group) {
    if (group.isMember) {
      return this.router.transitionTo('app.group', group.id);
    }

    const context = 'home_recommendations';
    showGroupPreviewDialog(this.dynamicDialogs, group, { context });
  }

  @action
  seeAllGroups(event) {
    event.stopPropagation();

    this.dynamicDialogs.openDialog('browse-communities-dialog', {
      theme: Theme.GROUP,
    });
  }

  @action
  joinGroup(group, e) {
    e?.stopPropagation();

    // use logic from group-preview-dialog for joining
    showGroupPreviewDialog(this.dynamicDialogs, group, {
      isJoinIntentFlow: true,
      context: 'home_recommendations'
    });
  }

  @action
  hideSuggestion(group, event) {
    event.stopPropagation();

    DiscoverApi.hideGroupSuggestion(group.id)
      .then(() => {
        set(group, 'hidden', true);
        // wait for the animation to complete
        later(() => this.groups.removeObject(group), 150);
      });
  }
}
